import { useTranslation } from 'react-i18next';
import '../loyalty.css';

interface Props {
  /** On-site payment is offered by this restaurant: the way out is one tap away. */
  canPayOnsite: boolean;
  onPayOnsite: () => void;
  /** Where it is shown (the loyalty step, the payment step) — for tests. */
  where: string;
}

/**
 * SC-1091 — the chosen advantage leaves under 0,50 € to pay ONLINE. Stripe refuses
 * a card payment that small and sale_api refuses the order (`online_amount_too_small`),
 * so the client says it up front instead of offering a zero-amount card form or a
 * submit that would bounce: pay on site (one tap, when the restaurant offers it) or
 * pick another advantage.
 */
export default function OnlineTooSmallNotice({ canPayOnsite, onPayOnsite, where }: Props) {
  const { t } = useTranslation();
  return (
    <div
      role="alert"
      data-testid={`online-too-small-${where}`}
      className="loyalty-scope mt-3 rounded-btn-sm border-2 border-solid border-sale-red bg-cream px-3 py-2 font-mono text-sm text-ink"
    >
      <p className="m-0">⚠ {canPayOnsite ? t('loyalty.checkout.tooSmall') : t('loyalty.checkout.tooSmallNoOnsite')}</p>
      {canPayOnsite && (
        <button
          type="button"
          onClick={onPayOnsite}
          data-testid={`online-too-small-onsite-${where}`}
          className="mt-2 min-h-[44px] rounded-btn-sm border-2 border-solid border-ink bg-mint px-4 font-display text-sm text-[var(--on-primary)]"
        >
          {t('checkout.payOnsite')}
        </button>
      )}
    </div>
  );
}
